<template>
  <div class="card-body">
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <a
          href="#detail"
          class="nav-link active"
          role="tab"
          data-toggle="tab"
          id="detail-tab"
          aria-controls="detail"
          aria-selected="true"
        >
          <i class="fa fa-info-circle"></i>&nbsp;&nbsp;N-Central Customer
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#devices"
          class="nav-link"
          role="tab"
          data-toggle="tab"
          id="devices-tab"
          aria-controls="devices"
          aria-selected="true"
        >
          <i class="fa fa-tablet"></i>&nbsp;&nbsp;Devices
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#spackages"
          class="nav-link"
          role="tab"
          data-toggle="tab"
          id="spackage-tab"
          aria-controls="spackages"
          aria-selected="true"
        >
          <i class="fa fa-box"></i>&nbsp;&nbsp;Override Package Prices
        </a>
      </li>
    </ul>
    <form class="tab-content">
      <div
        class="tab-pane fade show active"
        id="detail"
        role="tabpanel"
        aria-labelledby="detail-tab"
      >
        <div class="form-group row mt-3">
          <label class="col-md-3 col-form-label">Customer Description:</label>
          <div class="col-md-4">
            <input
              type="text"
              class="form-control"
              readonly
              disabled
              v-model="
                saleDefinition.definition.nCentralCustomer.customerDescription
              "
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label">Customer Access Code:</label>
          <div class="col-md-4">
            <input
              type="text"
              class="form-control"
              readonly
              disabled
              v-model="
                saleDefinition.definition.nCentralCustomer.customerAccessCode
              "
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label">Billing from:</label>
          <div class="col-md-4">
            <v-select
              :options="periods"
              placeholder="Select Billing From"
              v-model="saleDefinition.definition.nCentralCustomer.billFrom"
              :get-option-label="getLabel"
            ></v-select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label">Billing type:</label>
          <div class="col-md-4">
            <v-select
              :options="billingTypes"
              placeholder="Select Billing Type"
              v-model="saleDefinition.definition.nCentralCustomer.billingType"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <button class="btn btn-success" @click="saveSale()" type="button">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane"
        id="devices"
        role="tabpanel"
        aria-labelledby="devices-tab"
      >
        <div class="row">
          <div class="input-group mt-3 mb-3 col-2">
            <button type="button" @click="editDevice()" class="btn btn-success text-white border-0" :disabled="selectedRows.length == 0 || isSaving">Edit Selected Devices</button>
          </div>
          <div class="col-10">
            <div class="form-group pull-right mt-3">
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Search" v-model="searchTerm">
                    <div class="input-group-append">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                    </div>
                    <span class="input-group-text ml-2">{{ filteredDevices.length }} device{{ filteredDevices.length !== 1 ? 's' : '' }}</span>
                </div>
            </div>
          </div>
        </div>
        <div class="table-responsive table-bordered device-table">
          <table class="table text-nowrap">
            <thead>
              <tr class="dark-row">
                <th style="text-align:center">
                  <input type="checkbox" :checked="saleDefinition.definition.nCentralCustomer.manageddevices.length == selectedRows.length" @change="addRemoveToGlobal">
                </th>
                <th @click="sortBy('nCentralDeviceName')">Device Name
                  <i class="fa fa-sort-asc float-right" v-if="sortKey == 'nCentralDeviceName' && reverse"></i>
                  <i class="fa fa-sort-desc float-right" v-if="sortKey == 'nCentralDeviceName' && !reverse"></i>
                </th>
                <th @click="sortBy('siteName')">Site
                  <i class="fa fa-sort-asc float-right" v-if="sortKey == 'siteName' && reverse"></i>
                  <i class="fa fa-sort-desc float-right" v-if="sortKey == 'siteName' && !reverse"></i>
                </th>
                <th @click="sortBy('created')">Created
                  <i class="fa fa-sort-asc float-right" v-if="sortKey == 'created' && reverse"></i>
                  <i class="fa fa-sort-desc float-right" v-if="sortKey == 'created' && !reverse"></i>
                </th>
                <th @click="sortBy('deviceClass')">Device Class
                  <i class="fa fa-sort-asc float-right" v-if="sortKey == 'deviceClass' && reverse"></i>
                  <i class="fa fa-sort-desc float-right" v-if="sortKey == 'deviceClass' && !reverse"></i>
                </th>
                <th @click="sortBy('supportPackage.description')">Supporting Service
                  <i class="fa fa-sort-asc float-right" v-if="sortKey == 'supportPackage.description' && reverse"></i>
                  <i class="fa fa-sort-desc float-right" v-if="sortKey == 'supportPackage.description' && !reverse"></i>
                </th>
                <th>
                  <TableToFile
                    small
                    fileName="NCentral_Devices"
                    :fieldProp="exportFields"
                    :dataProp="exportData"
                    :propDisable="filteredDevices.length === 0"
                  />
                </th>
              </tr>
            </thead>
            <tbody v-if="filteredDevices.length > 0">
              <tr
                v-for="(device, index) in filteredDevices"
                :key="index"
                :class="{ 'selectedRow' : isRowSelected(device.objKey) }"
              >
                <td style="width: 2%; text-align:center"><input type="checkbox" :id="device.objKey" :checked="isRowSelected(device.objKey)" @change="addRemoveToSelected"></td>
                <td>
                  <a
                    :href="$config.urlToNCentral + device.nCentralDeviceNumber"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ device.nCentralDeviceName }}
                  </a>
                </td>
                <td>{{ device.siteName.length > 0 ? device.siteName : '--' }}</td>
                <td>{{ dateFormat(device.created) }}</td>
                <td>{{ device.deviceClass }}</td>
                <td>{{ device.supportPackage.description }}
                  <!-- <span class="badge badge-info" v-if="existingPackageIds.has(device.supportPackage.supportPackageNumber)">
                    Overwritten
                  </span> -->
                </td>
                <td style="text-align:center"><button type="button" @click="editDevice(device)" class="btn btn-success text-white border-0" :disabled="isSaving || selectedRows.length > 0"><i class="fa fa-edit"></i></button></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6">No Managed Devices</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="tab-pane"
        id="spackages"
        role="tabpanel"
        aria-labelledby="spackage-tab"
      >
        <NCentralSalePackagePricing :productNumber="this.saleDefinition.sale.productNumber" :saleNumber="saleNumber" :supportPackages="saleDefinition.selectableOptions.supportPackage" 
        :userEditRight="this.userContainsPermission(['ADMIN', 'PRODUCT_MANAGER', 'SENIOR_TECHNICAL_STAFF'])"/>
      </div>
    </form>
    <modal :title="selectedRows.length == 0 ? 'Edit Device' : 'Edit Multiple Devices'" ref="editDeviceModal" @save="saveSale()">
      <form class="form-row">
        <div class="form-group col-md-12" v-if="selectedRows.length == 0">
          <label>Package</label>
          <v-select
            name="Package"
            label="description"
            valueProp="supportPackageNumber"
            :options="packageOptions"
            v-model="selectedDevice.supportPackageNumber"
          >
          </v-select>
        </div>
        <div class="form-group col-md-12" v-else>
          <label>Package</label>
          <v-select
            name="Package"
            placeholder="Select a Package"
            label="description"
            valueProp="supportPackageNumber"
            :options="packageOptions"
            v-model="selectedPackage"
          >
          </v-select>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import SaleFunctions from "@/pages/Services/SaleFunctions";
import Modal from '@/components/GeneralComponents/Modal'
import TableToFile from '@/components/GeneralComponents/TableToFile'
import NCentralSalePackagePricing from "@/components/Admin/NCentralSalePackagePricing";

export default {
  extends: SaleFunctions,
  components: {
    Modal,
    TableToFile,
    NCentralSalePackagePricing
  },
  watch: {
    saleDefinition: {
      deep: true,
      handler(newSaleDef, oldSaleDef) {
        if (oldSaleDef.sale.description != newSaleDef.sale.description && this.$parent.$refs.serviceTitle) {
          this.$parent.$refs.serviceTitle.reloadSale();
        }
      },
    },
  },
  data() {
    return {
      saleNumber: this.$route.params.saleNumber,
      saleDefinition: {
        definition: {
          nCentralCustomer: {
            manageddevices: [],
          },
        },
        sale: {},
        selectableOptions: {
          supportPackage: []
        }
      },
      periods: [],
      billingTypes: [],
      isSaving: false,
      
      selectedDevice: [],
      selectedPackage: null,
      selectedRows: [],
      selectedGlobal: [],
      packageOptions: [],

      devicesFiltered: [],
      searchTerm: '',
      sortKey: 'created',
      reverse: false,

      exportFields: {
        'Site': 'siteName',
        'Device Name': 'nCentralDeviceName',
        'Customer': 'nCentralCustomerName',
        'Device Class': 'deviceClass',
        'Supporting Service': 'supportPackageDescription',
        'Created': 'created'
      },
    };
  },
  computed: {
    filteredDevices() {
          this.devicesFiltered = this.saleDefinition.definition.nCentralCustomer.manageddevices;

          if (this.searchTerm) {
              this.devicesFiltered = this.devicesFiltered.filter((device) => 
                device.nCentralDeviceName.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                device.nCentralCustomerName.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                device.siteName.toLowerCase().includes(this.searchTerm) ||
                device.created.toString().includes(this.searchTerm) ||
                device.deviceClass.toString().includes(this.searchTerm) ||
                device.supportPackage.description.toString().includes(this.searchTerm)
              );
          }

          if (this.reverse) {
              return _.orderBy(this.devicesFiltered, this.sortKey, 'asc');
          } else {
              return _.orderBy(this.devicesFiltered, this.sortKey, 'desc');
          }
      },
    exportData() {
      return this.filteredDevices.map(device => ({
        ...device,
        supportPackageDescription: device.supportPackage ? device.supportPackage.description : ''
      }));
    },
    // existingPackageIds() {
    //   return new Set(this.salePackages.map(pkg => pkg.supportPackageNumber));
    // }
  },  
  mounted() {
    this.loadSale();
    this.loadBilling();
    this.getOverridePackages();
  },
  methods: {
    loadSale() {
      $("#saleLoadingSpinner").show();
      this.toggleSaving();
      this.getSaleDefinition(this.saleNumber)
        .then(
          (response) => {
            this.selectedRows = [];
            this.saleDefinition = response.data;
            this.packageOptions = this.saleDefinition.selectableOptions.supportPackage;
            
          },
          (error) => {
            this.showError("Error fetching Sale Definition", error);
            console.error(error);
          }
        )
        .finally(() => {
          $("#saleLoadingSpinner").hide();
          this.toggleSaving();
        });
    },
    loadBilling() {
      this.$http
        .get(this.$config.aimsAPI + "system/billingperiods?max=" + 3)
        .then(
          (response) => {
            this.periods = response.data;
          },
          (error) => {
            this.showError("Error fetching billing periods", error);
            console.error(error);
          }
        );

      this.$http.get(this.$config.aimsAPI + "system/billingtypes").then(
        (response) => {
          this.billingTypes = response.data;
        },
        (error) => {
          this.showError("Error fetching Billing Types", error);
          console.error(error);
        }
      );
    },
    getOverridePackages() {
      this.$http.get(this.$config.aimsAPI + "pricing/overridepackages/" + this.saleNumber).then(
        (response) => {
          this.salePackages = response.data;
        },
        (error) => {
          this.showError("Error fetching Support Packages", error);
          console.error(error);
        }
      );
    },
    hasSalePackage(supportPackageNumber) {
      return this.salePackages.some(pkg => pkg.supportPackageNumber === supportPackageNumber);
    },
    toggleSaving() {
      this.isSaving = !this.isSaving;
    },
    getLabel(period) {
      return this.prettifyBillingPeriod(period);
    },
    saveSale() {
      this.toggleSaving();
      this.$refs.editDeviceModal.isLoading();

      if (this.selectedRows.length > 0) {
        for (let i = 0; i < this.selectedRows.length; i++) {
          for (let j = 0; j < this.saleDefinition.definition.nCentralCustomer.manageddevices.length; j++) {
            if(this.selectedRows[i] == this.saleDefinition.definition.nCentralCustomer.manageddevices[j].objKey) {
              this.saleDefinition.definition.nCentralCustomer.manageddevices[j].supportPackageNumber = this.selectedPackage;
            }
          }
        }
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http.put(this.$config.aimsAPI + "sales/definition/" + this.saleDefinition.sale.saleNumber + "/update", this.saleDefinition)
            .then((response) => {
                this.$refs.editDeviceModal.close();
                this.toggleSaving();
                this.showSuccess("Save Success");
                this.loadSale();
              },
              (error) => {
                this.toggleSaving();
                console.error(error);
                this.showError("Error Saving NCentral Sale", error);
                this.loadSale();
              }
            ).finally(() => {
              this.$refs.editDeviceModal.isLoading();
              this.selectedPackage = null;
            });
        }
      });
    },
    editDevice(device) {
      if (this.selectedRows.length == 0) {
        this.selectedDevice = device;
      }
      
      this.$refs.editDeviceModal.open();
    },
    isRowSelected(data){
      var isSelected = false;

      for (let i = 0; i < this.selectedRows.length; i++) {
        if (this.selectedRows[i] == data) {
          isSelected = true;
        }
      }

      return isSelected;
    },
    addRemoveToSelected(e) {
      if (e.target.checked) {
        this.selectedRows.push(e.target.id);
      } else {
        this.selectedRows = this.selectedRows.filter((i) => i != e.target.id);
      }
    },
    addRemoveToGlobal(e) {
      if (e.target.checked) {
        this.selectedRows = [];
        for (let i = 0; i < this.saleDefinition.definition.nCentralCustomer.manageddevices.length; i++) {
          this.selectedRows.push(this.saleDefinition.definition.nCentralCustomer.manageddevices[i].objKey);
        }
      } else {
        this.selectedRows = [];
      }
    },
    sortBy(sortKey) {
        this.reverse = (this.sortKey == sortKey) ? ! this.reverse : false;
        this.sortKey = sortKey;
    },
  },
};
</script>

<style lang="scss" scoped>
.dark-row {
  th {
    background-color: #3a3f51;
    color: #FFFFFF;

    position: sticky;
    top: 0;
    z-index: 2;
  }
}
.input-group > .v-select > .v-select-toggle {
  padding: 0.249rem 0.75rem !important;
}

.selectedRow {
  background-color: rgb(225, 225, 225);
}
</style>
